import Template from 'backbone/platform/templates/assets/assets_collection_tile.js.hamlc'
import AssetPickerAssetView from 'backbone/platform/views/assets/asset_picker_asset_view.js'

export default class AssetsCollectionTileView
  template: Template

  assetViewClass: AssetPickerAssetView

  viewStyle: "tile-view"

  _renderCollection: ->
    @collection.each (asset) =>
      assetView = new @assetViewClass
        asset: asset
        clickCallback: @options.clickCallback
      @subviews.push(assetView)
      @$(".thumbnail-container").append(assetView.render().$el)



// WEBPACK FOOTER //
// ./app/javascript/backbone/platform/views/assets/assets_collection_tile_view.js.coffee